import { render, staticRenderFns } from "./GramChartWrapperForList.vue?vue&type=template&id=2472e945&scoped=true"
import script from "./GramChartWrapperForList.vue?vue&type=script&lang=ts"
export * from "./GramChartWrapperForList.vue?vue&type=script&lang=ts"
import style0 from "./GramChartWrapperForList.vue?vue&type=style&index=0&id=2472e945&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2472e945",
  null
  
)

export default component.exports